const getFirstLetter = (str) => {
  if (!str) return null;
  const firstChar = str.charAt(0);
  if (/^[a-zA-Z]+$/.test(firstChar)) {
    return firstChar.toUpperCase();
  }
  return null;
};
export default getFirstLetter;
